import { FallbackError } from '@repo/zolintra-ui';
// Views Public
import Login from '../views/Login/Login';
import HomeRedirect from './HomeRedirect';
// Views Privates
import PlanningRemoteWorkingAndLeave from '../views/RemoteWorkingAndLeave/PlanningRemoteWorkingAndLeave';

import ListRemoteWorking from '../views/RemoteWorkingAndLeave/ListRemoteWorking';
import AdminListRemoteWorking from '../views/RemoteWorkingAndLeave/AdminListRemoteWorking';

import ListLeave from '../views/RemoteWorkingAndLeave/ListLeave';
import AdminListLeave from '../views/RemoteWorkingAndLeave/AdminListLeave';

import Settings from '../views/RemoteWorkingAndLeave/Settings';

// Providers
import { DialogProvider } from '../hooks/useDialog';

// Permissions
import ProtectedRoutes from './ProtectedRoutes';
import { PERMISSIONS } from '../permissions/hasPermission';

export default [
  // PUBLIC ROUTES
  {
    path: '/login',
    element: (
      <Login />
    ),
  },
  {
    path: '/',
    element: (
      <HomeRedirect />
    ),
  },
  // PRIVATE ROUTES
  {
    path: '/planning',
    element: (
      <ProtectedRoutes>
        <DialogProvider>
          <PlanningRemoteWorkingAndLeave />
        </DialogProvider>
      </ProtectedRoutes>
    ),
    errorElement: <FallbackError />,
  },
  {
    path: '/leaves',
    element: (
      <ProtectedRoutes permission={PERMISSIONS.GET_OWN_LEAVE_POST}>
        <DialogProvider>
          <ListLeave />
        </DialogProvider>
      </ProtectedRoutes>
    ),
    errorElement: <FallbackError />,
  },
  {
    path: '/leaves/admin',
    element: (
      <ProtectedRoutes permission={PERMISSIONS.GET_ANY_LEAVE_POST}>
        <DialogProvider>
          <AdminListLeave />
        </DialogProvider>
      </ProtectedRoutes>
    ),
    errorElement: <FallbackError />,
  },
  {
    path: '/remote-workings',
    element: (
      <ProtectedRoutes permission={PERMISSIONS.GET_OWN_REMOTE_WORKING_POST}>
        <DialogProvider>
          <ListRemoteWorking />
        </DialogProvider>
      </ProtectedRoutes>
    ),
    errorElement: <FallbackError />,
  },
  {
    path: '/remote-workings/admin',
    element: (
      <ProtectedRoutes permission={PERMISSIONS.GET_ANY_REMOTE_WORKING_POST}>
        <DialogProvider>
          <AdminListRemoteWorking />
        </DialogProvider>
      </ProtectedRoutes>
    ),
    errorElement: <FallbackError />,
  },
  {
    path: '/settings',
    element: (
      <ProtectedRoutes permission={PERMISSIONS.GET_CONFIGURATION}>
        <DialogProvider>
          <Settings />
        </DialogProvider>
      </ProtectedRoutes>
    ),
    errorElement: <FallbackError />,
  },
];
